import { apiSlice } from './apiSlice';
import { timeAgo } from '../../utilities/format';

/**
 * The tone a row is drawn in — which glyph it wears and which of the app's
 * signal colours it takes. The payload carries no type of its own
 * (`data.data.screen` only repeats the title), so it is read off the wording,
 * which is all the list has to work with.
 *
 * Four, in the order they are tested: something went wrong, something was won,
 * something is coming up, and — for everything left — a step forward. The
 * order matters, since "your payout was rejected" says both approve-ish and
 * reject-ish words and must read as the bad news it is.
 */
const toneOf = (note) => {
  const text = `${note.title ?? ''} ${note.body ?? ''}`.toLowerCase();
  if (/reject|fail|breach|disqualif|expire|declin/.test(text)) return 'danger';
  if (/approv|pass|success|complet|credit|won\b|win\b/.test(text)) return 'success';
  if (/remind|closes|closing|starts|deadline|tomorrow|upcoming/.test(text)) return 'reminder';
  return 'info';
};

/** API row → what the bell and the phone's account sheet both  render. */
export const toNotification = (note) => ({
  id: note.id,
  title: note.title,
  message: note.body,
  time: timeAgo(note.sent_at),
  // Kept alongside the "2 hours ago" line: the reading pane dates a message
  // properly, and re-parsing a string the row already has is silly.
  sentAt: note.sent_at,
  read: note.read,
  type: toneOf(note),
});

export const notificationsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /** Paginated: rows under `results`, total under `count`. `search` filters the text. */
    getNotifications: builder.query({
      query: (params) => ({
        url: '/notifications/',
        params,
      }),
      providesTags: ['Notification'],
    }),

    markNotificationRead: builder.mutation({
      query: (id) => ({
        url: `/notifications/${encodeURIComponent(id)}/read/`,
        method: 'POST',
      }),
      invalidatesTags: ['Notification'],
    }),

    markAllNotificationsRead: builder.mutation({
      query: () => ({
        url: '/notifications/mark_all/',
        method: 'POST',
      }),
      invalidatesTags: ['Notification'],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useMarkNotificationReadMutation,
  useMarkAllNotificationsReadMutation,
} = notificationsApi;
